import { BallotRecountIcon } from './BallotRecountIcon';

/**
 * author: Michael Irigoyen
 * id D0C76005-3272-4189-A061-E344D9BAB0C6
 * name ballot-recount
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ballot-recount.svg
 * tags
 */
export const VoteRecountIcon = BallotRecountIcon;
export default VoteRecountIcon